import { render, staticRenderFns } from "./ViewedObjects.vue?vue&type=template&id=6001d89e&"
import script from "./ViewedObjects.vue?vue&type=script&lang=js&"
export * from "./ViewedObjects.vue?vue&type=script&lang=js&"
import style0 from "./ViewedObjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports